import ClipboardM from "./recordm.model.clipboard";
import UriBuilder from "../helpers/module.uribuilder";

const BEHAVIORS = {
    SAVE: "save",
    SAVE_EDIT: "save-edit",
    SAVE_CREATE_NEW: "save-create-new"
}

const DEFAULT_BEHAVIORS = [
    {
        name: BEHAVIORS.SAVE,
        icon: "icon-ok"
    }
];

/**
 * @param behaviorsArray an array of sae behaviors
 *    Save behaviors should be like:
 *       {
 *          name: "save",               // Mandatory
 *          label: "Save",              // (Optional) Custom label for the button. Defaults to the name value
 *          icon: "icon-ok",            // (Optional) Custom icon for the button
 *          cssClasses: "some-class",   // (Optional) CSS classes to add to the action button
 *          newInstanceFields: []       // (Optional for save-create-new) an Array or a function:
 *                                      //      * Array: an array containing info about fields to use when creating a new instance (eg: ["Field 1", {"Field 2":"hardcoded value"}])
 *                                      //          * String element: the name of the field to fill on the new instance. Its value is obtained from the current instance being created/updated
 *                                      //          * Object: Field-value pair to use on the new instance. Its value is hardcoded
 *                                      //      * Function: a function that returns an Array like the previous one. It receives the current instance data as a parameter (eg: function(instanceData){})
 *       }
 */
const SaveBehaviorsM = function (behaviorsArray){
    let _behaviorsArray = [].concat(DEFAULT_BEHAVIORS);

    if(Array.isArray(behaviorsArray) && behaviorsArray.length > 0){
        const unknownBehavs = behaviorsArray.filter((behav) => !Object.values(BEHAVIORS).includes(behav.name));

        if(unknownBehavs.length > 0){
            window.console.warn("Some instance save behaviors are unknown or do not have a name. Going to ignore them", unknownBehavs);
        }

        const finalBehaviors = behaviorsArray.filter((behav) => Object.values(BEHAVIORS).includes(behav.name));

        if(finalBehaviors.length > 0){
            // The "save" behavior should always come first, for compatibility
            if(finalBehaviors.length > 1) {
                const saveBehavIdx = finalBehaviors.findIndex((behavior) => behavior.name === BEHAVIORS.SAVE);

                if(saveBehavIdx > 0){
                    const saveBehav = finalBehaviors.splice(saveBehavIdx, 1);
                    finalBehaviors.splice(0, 0, saveBehav);
                }
            }

            _behaviorsArray = finalBehaviors;
        }
    }

    return {
        getBehaviors: function (){
            return _behaviorsArray;
        },
        getDefaultBehaviors: function (){
          return DEFAULT_BEHAVIORS;
        },
        //callbacks.afterSave, callbacks.afterSaveEdit, callbacks.afterSaveCreateNew
        getActionFor: function(behaviorName, callbacks) {
            const behavior = _behaviorsArray.find((behavior) => behavior.name === behaviorName);

            switch (behaviorName) {
                case BEHAVIORS.SAVE_EDIT:
                    return (typeof callbacks.afterSaveEdit == 'function')
                           ? callbacks.afterSaveEdit
                           : SaveBehaviorsM.ACTIONS[BEHAVIORS.SAVE_EDIT];

                case BEHAVIORS.SAVE_CREATE_NEW:
                    return (typeof callbacks.afterSaveCreateNew == 'function')
                           ? callbacks.afterSaveCreateNew
                           : SaveBehaviorsM.ACTIONS[BEHAVIORS.SAVE_CREATE_NEW](behavior.newInstanceFields);

                default:
                    // By default, return the received "saveActionFn"
                    // This is possible only because the unknown behaviors are filtered out when building a new instance
                    return callbacks.afterSave;
            }
        }
    }
};

SaveBehaviorsM.ACTIONS = {};

SaveBehaviorsM.ACTIONS[BEHAVIORS.SAVE_EDIT] =  function (instanceData){
    // Timeout to wait for possible IntegrationM updates to this instance
    setTimeout(function() {
        // Use window.location.replace so that the current page is replaced by this new one in the browser history
        // This way, the "Back" button on the new page will return to the page prior to the current one
        window.location.replace(`#/${UriBuilder.buildUriForInstance(instanceData.id)}`);
    }, 2000);
};


SaveBehaviorsM.ACTIONS[BEHAVIORS.SAVE_CREATE_NEW] = function(newInstanceFields){

    return function (instanceData){
        let fields = newInstanceFields || [];

        const definitionId = instanceData.jsonDefinition.id;
        let newInstanceUrl = `#/${UriBuilder.buildUriForCreateInstance(definitionId)}`;

        if(typeof fields === 'function'){
            fields = fields(instanceData);
        }

        if(Array.isArray(fields) && fields.length > 0){

            const newInstanceUrlData = [];

            fields.forEach((field) => {
                // If it's a string, assume it's the field name and get its value from the instance being saved
                // If it's an object and contains the keys "name" and "value", use them
                if(typeof field === "string"){
                    const instanceField = instanceData.fields.find((f) => f.fieldDefinition.name === field);

                    if(instanceField && instanceField.value !== undefined){
                        newInstanceUrlData.push({
                            "targetField": field,
                            "value": instanceField.value
                        });
                    }

                } else if(typeof field === "object" && !Array.isArray(field) && Object.keys(field).length > 0) {
                    const fieldName = Object.keys(field)[0];
                    newInstanceUrlData.push({
                        "targetField": fieldName,
                        "value": field[fieldName]
                    });
                }
            });

            if(newInstanceUrlData.length > 0){
                const newInstanceUrlDataStr = JSON.stringify(new ClipboardM().buildClipboardObject(newInstanceUrlData));
                newInstanceUrl = `#/${UriBuilder.buildUriForCreateInstance(definitionId, newInstanceUrlDataStr)}`;
            }
        }

        // Use window.location.replace so that the current page is replaced by this new one in the browser history
        // This way, the "Back" button on the new page will return to the page prior to the current one
        window.location.replace(newInstanceUrl);
    }
};

export default SaveBehaviorsM;
